import { render, staticRenderFns } from "./PatentPriorityList.vue?vue&type=template&id=6eed8163&"
import script from "./PatentPriorityList.vue?vue&type=script&lang=js&"
export * from "./PatentPriorityList.vue?vue&type=script&lang=js&"
import style0 from "./PatentPriorityList.vue?vue&type=style&index=0&id=6eed8163&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports